<template>
  <v-card class="mx-auto">
    <v-card-text class="pa-5 black--text">
      <v-row class="mx-2">
        <v-col cols="12" md="12" sm="12">
          <div class="text-h6 my-3">Informasi Umum</div>
          <base-form-generator :schema="schema.pelapor" v-model="form" />
        </v-col>
        <v-col cols="12">
          <template v-if="petugas.length">
            <div class="container">
              <v-toolbar flat>
                <v-toolbar-title class="body-1">
                  <span>{{ petugas.length }}</span> Fasilitator Terpilih
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-spacer />
                <v-text-field dense outlined v-model="keywords.petugas" placeholder="Cari Data PA"></v-text-field>
              </v-toolbar>
              <v-spacer />
              <v-row v-for="item in filteredPetugas" :key="item.ptk_id">
                <v-col cols="12" md="4" sm="12">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <v-list-item-title>
                        <v-label color="caption"><small>Nama Fasilitator </small></v-label>
                      </v-list-item-title>
                      <div class="blue--text">
                        {{ $getDeepObj(item, 'ptk.nama') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small>No.UKG </small></v-label>
                      </v-list-item-title>
                      <div class="link black--text body-2">
                        {{ $getDeepObj(item, 'ptk_id') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <div class="link black--text body-2">
                        <v-chip v-if="+item.ptk_id === +pelapor" class="ma-2" color="green" text-color="white">
                          <v-icon left>mdi-check</v-icon>Pelapor
                        </v-chip>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-pagination class="my-3" v-model="pagePetugas" :length="limit.petugas + 1" circle></v-pagination>
            </div>
          </template>
        </v-col>
        <v-col cols="12">
          <template v-if="sekolah.length">
            <div class="container">
              <v-toolbar flat>
                <v-toolbar-title class="body-1">
                  <span>{{ sekolah.length }}</span> Sekolah Terpilih
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-spacer />
                <v-text-field dense outlined v-model="keywords.sekolah" placeholder="Cari Data Sekolah"></v-text-field>
              </v-toolbar>
              <v-spacer />
              <v-row v-for="item in filteredSekolah" :key="item.sekolah_id">
                <v-col cols="12" md="6" sm="12">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-hospital-building</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{
                          $getDeepObj(item, 'nama') ||
                            $getDeepObj(item, 'sekolah.data.nama') ||
                            $getDeepObj(item, 'sekolah.nama') ||
                            '-'
                        }}
                      </div>
                      <div class="black--text"
                        ><b>NPSN : </b>
                        {{
                          $getDeepObj(item, 'npsn') ||
                            $getDeepObj(item, 'sekolah.data.sekolah_id') ||
                            $getDeepObj(item, 'sekolah.sekolah_id') ||
                            '-'
                        }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small>Alamat Sekolah </small></v-label>
                      </v-list-item-title>
                      <div class="link black--text body-2">
                        {{
                          $getDeepObj(item, 'alamat') ||
                            $getDeepObj(item, 'sekolah.data.alamat') ||
                            $getDeepObj(item, 'sekolah.alamat') ||
                            '-'
                        }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-pagination class="my-3" v-model="pageSekolah" :length="limit.sekolah + 1" circle></v-pagination>
            </div>
          </template>
        </v-col>
        <v-col cols="12">
          <div class="text-h6 my-3">Jumlah Peserta, Fasilitator, dan Sekolah</div>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <base-form-generator :schema="schema.peserta" v-model="form"></base-form-generator>
              <div class="grey--text">
                Jika tidak terdapat peserta pada kolom jenjang yang tersedia dari sistem, silakan mengisikan dengan
                angka 0
              </div>
            </v-col>
            <v-col cols="12" md="6" sm="12" class="px-2">
              <span :class="[`px-0 body-2 grey--text`]" style="height: 24px">
                Total Peserta (Otomatis terisi dengan akumulasi semua data)
              </span>
              <v-text-field :value="pesertaTotal" disabled outlined dense></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <div class="text-h6 my-3">Deskripsi Kegiatan</div>
          <base-form-generator :schema="schema.deskripsi" v-model="form" />
        </v-col>
        <v-col cols="12">
          <div class="text-h6 my-3">Lampiran</div>
          <v-row>
            <v-col v-if="(form && form.modas.length === 2) || (form && form.modas[0] === 1)" cols="12" md="12" sm="12">
              <template v-for="(meeting, m) in form.rekaman_data">
                <v-row :key="m" no-gutters>
                  <v-col cols="12" :md="readOnly ? 10 : 9" sm="12">
                    <base-form-generator
                      :key="m"
                      :schema="schema.meetings"
                      v-model="form.rekaman_data[m]"
                      @input="getDurasi(form.rekaman_data[m], m)"
                    />
                  </v-col>
                  <v-col v-if="!readOnly" cols="12" md="3" sm="12">
                    <div class="mt-5 ml-2">
                      <v-btn class="mt-n2" color="error" depressed @click="onDelTautan(m)">
                        <v-icon left>mdi-delete</v-icon> Hapus
                      </v-btn>
                      <span class="blue--text pa-3">
                        {{ (durasis && durasis[Number(m)]) || '' }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <v-btn
                v-if="!readOnly"
                @click="onAddTautan"
                color="primary"
                elevation="0"
                class="my-3"
                :disabled="form.rekaman_data.length === 5"
              >
                <v-icon left dark>
                  mdi-plus
                </v-icon>
                Tambah Tautan
              </v-btn>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <v-row v-for="(berkas, b) in schema.berkas" :key="b">
                <v-col cols="12" sm="12" md="12">
                  <span class="blue--text">Lampiran {{ berkas.label }}</span>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-row v-for="(file, f) in berkas.berkases" :key="f" dense>
                    <v-col cols="12" md="9" sm="12">
                      <v-text-field :value="file.judul" readonly outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <div>
                        <v-btn color="success" depressed @click="onPreviewBerkas({}, file.url_berkas)">
                          <v-icon>mdi-eye</v-icon>
                          Preview
                        </v-btn>
                        <v-btn v-if="!readOnly" class="mx-1" color="red" dark depressed @click="onDeleteBerkas(file)">
                          <v-icon>mdi-delete</v-icon>
                          Hapus
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-btn
                    v-if="!readOnly"
                    color="primary"
                    depressed
                    :disabled="berkas.berkases.length >= 5"
                    @click="onChangeLampiran(berkas)"
                  >
                    <v-icon left>mdi-plus</v-icon> Tambah Berkas
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <span :class="[`px-0 body-2 blue--text`]" style="height: 24px">
                Dokumentasi Kegiatan
              </span>
              <v-row>
                <v-col cols="12" md="10" sm="12">
                  <v-text-field
                    placeholder="Unggah Dokumen Kegiatan"
                    readonly
                    outlined
                    dense
                    prepend-icon=""
                    @click="onUnggahKegiatan"
                  ></v-text-field>
                </v-col>
                <v-col v-if="!readOnly" cols="12" md="2" sm="12">
                  <v-btn class="primary" depressed @click="onUnggahKegiatan">
                    <v-icon left>mdi-upload</v-icon>
                    Unggah
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="berkasesKegiatan.length > 0" cols="12" md="12" sm="12">
              <div v-for="(item, i) in berkasesKegiatan" :key="i">
                <v-row dense>
                  <v-col cols="12" md="9" sm="12">
                    <v-text-field :value="item.judul" readonly outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <div>
                      <v-btn color="success" depressed @click="onPreviewBerkas({}, item.url_berkas)">
                        <v-icon left>mdi-eye</v-icon>
                        Preview
                      </v-btn>
                      <v-btn v-if="!readOnly" class="mx-2" color="red" dark depressed @click="onDeleteBerkas(item)">
                        <v-icon left>mdi-delete</v-icon>
                        Hapus
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <berkas ref="berkas" :jenis="jenis" :title="title" @upload="onAddBerkasSave" />
  </v-card>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import Berkas from './Berkas';
import { mapActions } from 'vuex';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isPelapor: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  components: { BaseFormGenerator, Berkas },
  data() {
    return {
      form: {},
      kegiatans: [],
      kegiatan: null,
      pelapor: null,
      sekolah: [],
      petugas: [],
      pageSekolah: 1,
      pagePetugas: 1,
      title: '',
      jenis: '',
      keywords: {
        petugas: '',
        sekolah: '',
      },
      popup: {
        title: '',
        api: 'lokakarya/getPA',
        key: 'sekolah_id',
      },
      durasis: [],
    };
  },
  computed: {
    schema() {
      return {
        pelapor: [
          {
            type: 'VTextField',
            name: 'nama',
            label: 'Nama Pendampingan Kelompok',
            labelColor: 'grey',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            dense: true,
            disabled: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VSelect',
            name: 'k_lokakarya_kegiatan_psp',
            label: 'Nama Kegiatan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.$getDeepObj(this, 'masters.lokakarya_kegiatan_psp')),
            required: true,
            outlined: true,
            singleLine: true,
            disabled: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VDatePicker',
            name: 'tgl_pelaksanaan',
            label: 'Waktu Pelaksanaan',
            labelColor: 'grey',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'lokasi',
            label: 'Tempat Pelaksanaan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VSelect',
            name: 'modas',
            label: 'Moda yang diterapkan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.$getDeepObj(this, 'masters.lokakarya_moda_psp') || {}),
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            multiple: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'durasi',
            label: 'Durasi (menit)',
            labelColor: 'grey',
            hint: 'wajib diisi',
            mask: '####',
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
        ],
        deskripsi: [
          {
            type: 'VTextarea',
            name: 'efektif',
            label: 'Tuliskan hal-hal yang sudah berjalan dengan efektif',
            labelColor: 'grey',
            hint: '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 12, sm: 12 },
          },
          {
            type: 'VTextarea',
            name: 'peningkatan',
            label: 'Tuliskan hal-hal yang perlu ditingkatkan',
            labelColor: 'grey',
            hint: '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 12, sm: 12 },
          },
        ],
        peserta: [
          {
            type: 'VTextField',
            name: 'jml_pa',
            label: 'Jumlah Fasilitator',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetail: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_pengawas',
            label: 'Jumlah Pengawas Sekolah',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_kasek',
            label: 'Jumlah Kepala Sekolah',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_tk',
            label: 'dari TK-PAUD',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_sd',
            label: 'dari SD',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_smp',
            label: 'dari SMP',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_sma',
            label: 'dari SMA',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_slb',
            label: 'dari SLB',
            labelColor: 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
        ],
        berkas: [
          {
            kBerkas: 1,
            key: 'presensi-peserta',
            label: 'Daftar hadir Peserta',
            berkases: (this.berkases || []).filter((s) => Number(s.k_lokakarya_berkas_psp) === 1) || [],
          },
          {
            kBerkas: 2,
            key: 'presensi-fasilitator',
            label: 'Daftar Hadir Fasilitator / Pengajar',
            berkases: (this.berkases || []).filter((s) => Number(s.k_lokakarya_berkas_psp) === 2) || [],
          },
          {
            kBerkas: 3,
            key: 'bukti-fisik',
            label: 'Bukti Fisik Dokumen yang Relevan (jika ada)',
            berkases: (this.berkases || []).filter((s) => Number(s.k_lokakarya_berkas_psp) === 3) || [],
          },
        ],
        meetings: [
          {
            type: 'VTextField',
            name: 'url_meeting',
            label: 'Rekaman Video Conference (jika ada) taruh URL, video rekaman disini',
            labelColor: 'secondary',
            hint: '',
            required: true,
            grid: { cols: 12, md: 12, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readonly,
            prependInnerIcon: 'mdi-video',
          },
        ],
      };
    },

    pesertaTotal() {
      let total = 0;
      const schema = this.schema.peserta;
      schema.forEach((key) => {
        total += Number(this.form[key.name] || 0);
      });
      return total;
    },

    filteredSekolah() {
      const page = this.pageSekolah;
      const data = [...this.sekolah].filter((item) => {
        return item.nama.toLowerCase().includes(this.keywords.sekolah.toLowerCase());
      });
      const start = page === 1 ? 0 : 5 * (page - 1);
      const finish = page === 1 ? 5 : data.length > page * 5 ? page * 5 : data.length;

      return data.slice(start, finish);
    },

    filteredPetugas() {
      const page = this.pagePetugas;
      const data = [...this.petugas].filter((item) => {
        return item.ptk.nama.toLowerCase().includes(this.keywords.petugas.toLowerCase());
      });
      const start = page === 1 ? 0 : 5 * (page - 1);
      const finish = page === 1 ? 5 : data.length > page * 5 ? page * 5 : data.length;

      return data.slice(start, finish);
    },

    berkases() {
      return this.$getDeepObj(this.detail, 'psp_kp_lokakarya_berkases') || [];
    },

    berkasesKegiatan() {
      const berkas = this.$getDeepObj(this.detail, 'psp_kp_lokakarya_berkases') || [];
      return berkas.filter((key) => key.k_lokakarya_berkas_psp === 6);
    },

    limit() {
      return {
        petugas: this.petugas.length === 5 ? 0 : parseInt((this.petugas.length || 0) / 5),
        sekolah: this.petugas.length === 5 ? 0 : parseInt((this.sekolah.length || 0) / 5),
      };
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('lokakarya', ['uploadBerkas', 'deleteBerkas']),

    initForm(value) {
      if (!value) return;
      const formulir = [
        ...(this.schema.pelapor || []),
        ...(this.schema.peserta || []),
        ...(this.schema.deskripsi || []),
      ];

      for (const item of formulir) {
        if (item.name) {
          this.$set(
            this.form,
            item.name,
            typeof value[item.name] === 'number' ? Number(value[item.name]) : this.$getDeepObj(value, item.name) || ''
          );
        }
      }

      const modas = this.$getDeepObj(value, 'psp_kp_lokakarya_modas');
      this.$set(
        this.form,
        'modas',
        modas.map((item) => item.k_lokakarya_moda_psp)
      );

      // Init Meeting URL
      const meeting = this.$getDeepObj(value, 'rekaman_data') || [];
      if (meeting.length > 0) {
        this.$set(this.form, 'rekaman_data', []);
        let formMeeting = [];

        meeting.forEach((item, index) => {
          formMeeting.push(item);
          this.durasis[index] = this.$durasiWaktu(this.$getDeepObj(item, 'durasi')) || null;
        });

        this.$set(this.form, 'rekaman_data', formMeeting);
      }

      // Init List Petugas
      this.petugas =
        value.psp_kp_lokakarya_pas.map((item) => {
          if (Number(item.is_pelapor) === 1) {
            this.pelapor = this.$getDeepObj(item, 'psp_profil_pa.ptk_id');
          }
          return item.psp_profil_pa;
        }) || [];

      // Init List Sekolah
      this.sekolah =
        value.psp_kp_lokakarya_sekolahs.map((item) => {
          return item.sekolah;
        }) || [];
    },

    reset() {
      this.$set(this, 'form', {
        rekaman_data: [],
      });
      this.$set(this, 'pelapor', null);
      this.$set(this, 'petugas', []);
      this.$set(this, 'sekolah', []);
      this.durasis = [];
    },

    onAddTautan() {
      this.form.rekaman_data.push({ url_meeting: '' });
    },

    onDelTautan(index) {
      this.form.rekaman_data.splice(index, 1);
      this.$delete(this.durasis, index);
    },

    onUnggahKegiatan() {
      if (this.readOnly) return;
      this.jenis = 'dokumentasi';
      this.title = 'Dokumen Kegiatan';
      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onDelete(obj, index) {
      const id = obj === 'sekolah' ? 'sekolah_id' : 'ptk_id';
      const findIndex = this[obj].findIndex((item) => Number(item[id]) === Number(index));
      if (findIndex > -1) {
        this[obj].splice(findIndex, 1);
      }
    },

    onDeleteBerkas(berkas) {
      if (this.readOnly) return;
      const kBerkas = this.$getDeepObj(berkas, `psp_kp_lokakarya_berkas_id`);
      const lokakaryaId = this.$getDeepObj(this.detail, 'psp_kp_lokakarya_id');
      this.$confirm(`Apakah Anda yakin ingin menghapus berkas <b>${berkas.judul}</b> ?`, 'Peringatan', {
        tipe: 'error',
      }).then(() => {
        this.deleteBerkas({
          lokakaryaId: lokakaryaId,
          id: kBerkas,
        }).then(() => {
          this.$success('Berkas berhasil di hapus');
          this.$emit('refresh', { psp_kp_lokakarya_id: lokakaryaId }, false);
        });
      });
    },

    onChangeLampiran(berkas) {
      if (this.readOnly) return;
      this.jenis = berkas.key;
      this.title = berkas.label;
      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    getValue() {
      const modas = this.$getDeepObj(this.form, 'modas') || [];
      let form = {};
      Object.keys(this.form).forEach((f, key) => {
        const keyReplace = this.schema.peserta.map((item) => item.name);
        if (keyReplace.includes(key)) {
          this.$set(form, key, (this.form && this.form[key]) || '');
        }
      });

      return Object.assign(
        {
          lokakarya: this.form,
        },
        {
          modas: modas.map((item) => {
            return {
              k_lokakarya_moda_psp: item,
            };
          }),
        }
      );
    },

    onAddBerkasSave(berkas) {
      const lokakaryaId = this.$getDeepObj(this.detail, 'psp_kp_lokakarya_id');
      const formData = new FormData();

      formData.append('label', this.jenis);
      formData.append('judul', berkas.judul);
      formData.append('file', berkas.file);

      this.$refs.berkas.startLoading();
      this.uploadBerkas({
        lokakaryaId,
        params: formData,
      })
        .then(() => {
          this.$emit('refresh', { psp_kp_lokakarya_id: lokakaryaId }, false);
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onPreviewBerkas(berkas, deffUrl = null) {
      const url = this.$getDeepObj(this.berkases, `${berkas.kBerkas}.url_berkas`);
      window.open(deffUrl || url, '_blank');
    },

    validate() {
      let status = true;

      if (!this.pelapor) {
        this.$error('Harap pilih pelapor terlebih dahlu');
        status = false;
        return;
      }

      return status;
    },

    getDurasi(item, index) {
      if (!item.url_meeting) return;
      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item.url_meeting }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },
  },
  watch: {
    initValue: 'initForm',
    'form.modas': function(value) {
      if (value.length === 2 || value[0] === 2) {
        this.$set(this.form, 'rekaman_data', []);
      }
    },
  },
};
</script>
